import React, {useEffect, useState} from 'react';
import {useActions} from "../../../hook/useActions";
import {useTypedSelector} from "../../../hook/useTypedSelector";
import {useNavigate} from "react-router-dom";

const AllReports = () => {
    // const [selectedDate, setSelectedDate] = useState<string>(() => {
    //     const today = new Date();
    //     const year = today.getFullYear();
    //     const month = String(today.getMonth() + 1).padStart(2, "0");
    //     const day = String(today.getDate()).padStart(2, "0");
    //     return `${year}-${month}-${day}`;
    // });
    const [selectedDate, setSelectedDate] = useState<string|undefined>(undefined);

    const {allPostReports} = useTypedSelector((store) => store.postPractice);
    const navigate = useNavigate();

    const {GetAllPostReports, ForceLoginUser} = useActions();

    const [notCompletedSort, setNotCompletedSort] = useState<{column: string, asc: boolean}>({column: "fullName", asc: true});
    const [completedSort, setCompletedSort] = useState<{column: string, asc: boolean}>({column: "fullName", asc: true});

    useEffect(() => {
        GetAllPostReports();
    }, []);

    useEffect(() => {
        if(selectedDate)
            GetAllPostReports(new Date(selectedDate));
    }, [selectedDate]);

    if(allPostReports == null){
        return (
            <div>Loading...</div>
        )
    }

    const sortArray = (arr: any[], column: string, asc: boolean) => {
        return [...arr].sort((a, b) => {
            if (column === "fullName") {
                return asc
                    ? a.fullName.localeCompare(b.fullName)
                    : b.fullName.localeCompare(a.fullName);
            }
            if (column === "percentCompleated") {
                return asc
                    ? a.percentCompleated - b.percentCompleated
                    : b.percentCompleated - a.percentCompleated;
            }
            return 0;
        });
    };

    const notCompleted = sortArray(
        allPostReports.filter((u: any) => u.percentCompleated === 0),
        notCompletedSort.column,
        notCompletedSort.asc
    );

    const completed = sortArray(
        allPostReports.filter((u: any) => u.percentCompleated > 0),
        completedSort.column,
        completedSort.asc
    );

    function handleForceLoginClick(id: string) {
        const data = {id: id};
        ForceLoginUser(data);
        navigate("/redirect");
    }

    return (
        <div className="container mt-4">
            <div className="mb-3 col-2">
                <label htmlFor="reportDate" className="form-label">
                    For Date:
                </label>
                <input
                    type="date"
                    id="reportDate"
                    className="form-control"
                    value={selectedDate}
                    onChange={e => setSelectedDate(e.target.value)}
                />
            </div>

            <div className="row">
                {/* Left Table */}
                <div className="col-md-6">
                    <h4>Users with 0%</h4>
                    <table className="table table-bordered table-striped">
                        <thead className="table-light">
                        <tr>
                            <th
                                style={{cursor: "pointer"}}
                                onClick={() =>
                                    setNotCompletedSort(s => ({
                                        column: "fullName",
                                        asc: s.column === "fullName" ? !s.asc : true
                                    }))
                                }
                            >
                                Full Name {notCompletedSort.column === "fullName" ? (notCompletedSort.asc ? "▲" : "▼") : ""}
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        {notCompleted.map((user: any) => (
                            <tr key={user.id}>
                                <td onClick={() => handleForceLoginClick(user.id)}>{user.fullName}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>

                {/* Right Table */}
                <div className="col-md-6">
                    <h4>Users with Progress</h4>
                    <table className="table table-bordered table-striped">
                        <thead className="table-light">
                        <tr>
                            <th
                                style={{cursor: "pointer"}}
                                onClick={() =>
                                    setCompletedSort(s => ({
                                        column: "fullName",
                                        asc: s.column === "fullName" ? !s.asc : true
                                    }))
                                }
                            >
                                Full Name {completedSort.column === "fullName" ? (completedSort.asc ? "▲" : "▼") : ""}
                            </th>
                            <th
                                style={{cursor: "pointer"}}
                                onClick={() =>
                                    setCompletedSort(s => ({
                                        column: "percentCompleated",
                                        asc: s.column === "percentCompleated" ? !s.asc : false
                                    }))
                                }
                            >
                                Percent Completed {completedSort.column === "percentCompleated" ? (completedSort.asc ? "▲" : "▼") : ""}
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        {completed.map((user: any) => (
                            <tr key={user.id}>
                                <td onClick={() => handleForceLoginClick(user.id)}>{user.fullName}</td>
                                <td>{user.percentCompleated}%</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default AllReports;
